import { loginUri } from 'Consts/sharedUris';
import { endSession } from 'State/actions';
import { historyWithForceRefresh } from 'State/history';
import { store } from 'State/store';

export const logOut = () => {
  // The history has to change before the dispatch to Redux in order to prevent a re-render of the advisor/client app
  // before react router switches to the login page. We use historyWithForceRefresh so that if there's a new JS bundle,
  // it can be loaded transparently to the member
  historyWithForceRefresh.push(loginUri);
  store.dispatch(endSession());
};
